// extracted by mini-css-extract-plugin
module.exports = {"ErrorStateDescription":"ErrorState_ErrorStateDescription__v41hs"};